﻿/**
 * portal-mini-launcher.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-mini-launcher.controller', portalMiniLauncherController);

	/** setup injection */
	portalMiniLauncherController.$inject = ['message.manager'];

	/** implementation */
	function portalMiniLauncherController(messageManager) {
		/** pubic properties */
		var vm = this;
		vm.active = false;

		/** public methods */
		vm.toggleLauncher = toggleLauncher;
		
		/** run init */
		init();

		/** public method implementations */

		/** show the app launcher */
		function toggleLauncher() {
			/** show the launcher and mask */
			if (vm.active) {
				vm.active = false;
				messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': false, 'window': null }});
			} else {
				vm.active = true;
				messageManager.setData('message', { 'key': 'module-callout-mask', 'value': { 'visible': true, 'window': 'portal-mini-launcher' }});
			}
		}

		/** private methods */

		/** initialize */
		function init() {
			/** set callbacks */
			messageManager.addCallback('message', messageReceiver, true);
		}

		/** watch for messages */
		function messageReceiver(message) {
			if (message.key && message.key === 'module-callout-mask' && (message.value.visible === false || (message.value.visible === true && message.value.window !== 'portal-mini-launcher'))) {
				vm.active = false;
			}
		}
	}
})();